/*
 * Copy to clipboard helper only with JS
 *
 * Ref: https://www.30secondsofcode.org/articles/s/copy-text-to-clipboard-with-javascript
 */
const copyToClipboard = (str: string) => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

export default copyToClipboard;
